import { useTranslation } from 'react-i18next';
import { TextSkeleton } from '@treezor/design-system';

import { UserCardOverview } from '@/features/cards/components/Overview/UserCardOverview';
import { useUserCardList } from '@/features/cards/hooks/useUserCardList';

import { OverviewItemLoader } from './OverviewItemLoader';

export function UserCard() {
  const { t } = useTranslation();
  const { isLoading, cards } = useUserCardList();

  if (!cards?.length && isLoading)
    return (
      <div className="flex flex-col gap-5">
        <TextSkeleton width={120} margin="2px 0" />
        <OverviewItemLoader />
        <OverviewItemLoader />
      </div>
    );

  if (!cards?.length) return null;

  return (
    <div className="flex flex-col gap-5">
      <h6 className="typo-h6-bold text-secondary">{t('pages.currentProfiles.cards.title')}</h6>
      <UserCardOverview cards={cards} />
    </div>
  );
}
